// test1034
(1034 && 0);
